export default "__VITE_ASSET__DC$1_cjD__"